/**
 * @deprecated
 * 이 파일은 하위 호환성을 위해 유지됩니다.
 * 새로운 코드는 hooks/ 폴더의 개별 파일을 사용하세요.
 *
 * @example
 * // 🚫 이전 방식 (여전히 작동하지만 권장하지 않음)
 * import { useTabTracking } from 'lib/analytics/react/hooks';
 *
 * // ✅ 새로운 방식 (권장)
 * import { useTabTracking } from 'lib/analytics/react/hooks/tabs';
 */

export * from "./hooks/index";
